<template>
  <v-autocomplete
    class="autoCompleted"
    outlined
    v-bind="$attrs"
    :items="list"
    v-on="$listeners"
    :search-input.sync="search"
    :value="value"
    @input="x => $emit('input', x)"
    :disabled="disabled"
    :menu-props="{ offsetY: true }"
    no-filter
    append-icon="mdi-magnify"
  >
    <template v-if="hasItemsSlot" v-slot:item="x">
      <slot :item="x.item" name="items"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { crudList } from '@/api/crud';
import api from '@/api';
import { debounce } from 'lodash';

export default {
  name: 'masterAutocomplete',
  props: {
    path: {},
    value: {},
    params: {},
    disabled: { type: Boolean, default: false },
    hasItemsSlot: { type: Boolean, default: false }, //TODO: replace with $slots
  },
  data() {
    return {
      list: [],
      search: null,
      debounceToGetData: debounce(this.reload, 500),
    };
  },
  methods: {
    async reload() {
      this.list = (await crudList(api, this.path, { search: this.search, ...this.params })).docs;

      const itemValuePropertyName = this.$attrs['item-value'];
      if (
        this.value &&
        itemValuePropertyName &&
        !this.list.find(
          item =>
            item[itemValuePropertyName] === this.value ||
            item[itemValuePropertyName] === this.value?.[itemValuePropertyName],
        )
      ) {
        this.list = this.list.concat(
          (
            await crudList(api, this.path, {
              filter: { [`${itemValuePropertyName}`]: this.value },
            })
          ).docs,
        );
      }
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(v) {
        this.debounceToGetData();
      },
    },
  },
};
</script>

<style lang="scss">
.autoCompleted .v-icon {
  transform: rotate(0deg) !important;
}
</style>
